module.exports = "/_next/static/images/ChooseFromDestinations-91d01a823fab337b464d6cb720ce1401.webp";